export default __webpack_public_path__ + "static/media/OCTDOM2025.39020787.png";